import Appropriate from 'lib/appropriate'

window['talent_pools#appropriate'] = function () {
  const form = $('#fill-position')
  new Appropriate({
    formSelector: form,
    onCandidateCheck: (checkedCount) => {
      $('[type="submit"]', form).attr('disabled', !checkedCount)
    }
  })
}
